import axios, { AxiosInstance, AxiosResponse, AxiosRequestConfig } from "axios";

export class RestApiClient {

    private client: AxiosInstance;
    private _forceRequestVerificationToken: boolean;

    constructor(baseUrl: string = null, forceRequestVerificationToken: boolean = false) {
        this.client = axios.create();
        if (baseUrl != null) {
            this.client.defaults.baseURL = baseUrl
        }
        this._forceRequestVerificationToken = forceRequestVerificationToken;
    }

    get<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
        config = this.tryAddRequestVerificationToken(config);

        return new Promise<T>((resolve, reject) => {
            this.client.get<T>(url, config).then((result) => {
                resolve(result.data);
            }).catch((reason) => {
                reject(reason);
            });
        });
    }

    post<T>(url: string, data: any, config?: AxiosRequestConfig): Promise<T> {
        config = this.tryAddRequestVerificationToken(config);

        return new Promise<T>((resolve, reject) => {
            this.client.post<T>(url, data, config).then((result) => {
                resolve(result.data);
            }).catch((reason) => {
                reject(reason);
            });
        });
    }


    patch<T>(url: string, data: any, config?: AxiosRequestConfig): Promise<T> {
        config = this.tryAddRequestVerificationToken(config);

        return new Promise<T>((resolve, reject) => {
            this.client.patch<T>(url, data, config).then((result) => {
                resolve(result.data);
            }).catch((reason) => {
                reject(reason);
            });
        });
    }

    delete<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
        config = this.tryAddRequestVerificationToken(config);

        return new Promise<T>((resolve, reject) => {
            this.client.delete(url, config).then((result) => {
                resolve(result.data);
            }).catch((reason) => {
                reject(reason);
            });
        });
    }

    put<T>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
        config = this.tryAddRequestVerificationToken(config);

        return new Promise<T>((resolve, reject) => {
            this.client.put<T>(url, data, config).then((result) => {
                resolve(result.data);
            }).catch((reason) => {
                reject(reason);
            });
        });
    }

    head<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
        config = this.tryAddRequestVerificationToken(config);

        return new Promise<T>((resolve, reject) => {
            this.client.head(url, config).then((result) => {
                resolve(result.data);
            }).catch((reason) => {
                reject(reason);
            });
        });
    }

    request<T>(config?: AxiosRequestConfig): Promise<T> {
        config = this.tryAddRequestVerificationToken(config);

        return new Promise<T>((resolve, reject) => {
            this.client.request<T>(config).then((result) => {
                resolve(result.data);
            }).catch((reason) => {
                reject(reason);
            });
        });
    }

    private tryAddRequestVerificationToken(config?: AxiosRequestConfig): AxiosRequestConfig {
        if (this._forceRequestVerificationToken) {
            console.log("_forceRequestVerificationToken");
            if (config == null || config.headers == null) {
                if ($('input[name="__RequestVerificationToken"]').val() == undefined) {
                    console.error("__RequestVerificationToken is undefined!");
                }
                config = { headers: { "X_CSRF_TOKEN": $('input[name="__RequestVerificationToken"]').val() } };
            }
            else if (config.headers["X_CSRF_TOKEN"] == undefined || config.headers["X_CSRF_TOKEN"] == null) {
                if ($('input[name="__RequestVerificationToken"]').val() == undefined) {
                    console.error("__RequestVerificationToken is undefined!");
                }
                config.headers["X_CSRF_TOKEN"] = $('input[name="__RequestVerificationToken"]').val();
            }
        }
        return config;
    }
}